import classNames from "classnames";
import React from "react";
import ButtonWithTooltip from "../buttonWithTooltip";
import locale from "./undoButton.locale";
import { Button } from "UiKit";
export default function UndoButton(props) {
    return props.useNewBtn ? (React.createElement(Button, { styleType: "text", size: "32", onClick: props.onUndo, tooltipMessage: locale.UNDO, elementAttr: props.elementAttr, disabled: props.disabled, iconOnly: true },
        React.createElement("i", { className: "icon-undo" }))) : (React.createElement(ButtonWithTooltip, { width: props.btnSize, height: props.btnSize, className: classNames("no-border", props.className), disabled: props.disabled, onClick: props.onUndo, popoverContent: locale.UNDO, elementAttr: props.elementAttr },
        React.createElement("i", { className: "icon-undo" })));
}
UndoButton.defaultProps = {
    btnSize: 28
};
